import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AnimatePresence, motion, useIsPresent } from 'framer-motion';
import { useCallback, useContext, useEffect, useState } from 'react';
import useWindowDimensions from '../hooks/useWindowDimensions';
import { ADD_TO_POST_TYPES, REMOVE_FROM_POST_TYPES, SET_FILTERED_POSTS, SET_POST_TYPES, store } from '../state/state';
import Checkbox from './Checkbox';
const TRANSITION_VH = 40;
const TRANSITION_SEC = 0.2;
const variants = {
    in: {
        y: '0',
        opacity: 1,
        transition: {
            duration: TRANSITION_SEC,
            ease: 'easeOut',
        },
    },
    out: {
        y: `-${TRANSITION_VH}vh`,
        opacity: 0,
        transition: {
            duration: TRANSITION_SEC,
            ease: 'easeOut',
        },
    },
};
const choices = [
    {
        label: 'View All',
        value: 'view-all',
        icon: ''
    },
    {
        label: 'Accommodation',
        value: 'accommodation',
        icon: 'accommodation'
    },
    {
        label: 'Attraction',
        value: 'attraction',
        icon: 'experience'
    },
    {
        label: 'Food and Drink',
        value: 'food_and_drink',
        icon: 'produce'
    },
    {
        label: 'General service',
        value: 'general_service',
        icon: 'general'
    },
    {
        label: 'Journey',
        value: 'journey',
        icon: 'trail'
    },
    {
        label: 'Information service',
        value: 'information_service',
        icon: 'information-services'
    },
    {
        label: 'Tour',
        value: 'tour',
        icon: 'camera'
    }
];
const RegionalMapFilters = ({ onEnter }) => {
    const isPresent = useIsPresent();
    const { width } = useWindowDimensions();
    const isTablet = width >= 1023;
    const [expanded, setExpanded] = useState(isTablet);
    const handleEnter = useCallback(() => {
        if (isPresent)
            onEnter?.();
    }, [isPresent, onEnter]);
    const globalState = useContext(store);
    const { state, dispatch } = globalState;
    useEffect(() => {
        if (isTablet) {
            setExpanded(true);
        }
    }, [expanded, isTablet]);
    const handleChange = (event) => {
        const target = event.target;
        let value;
        if (target.value === 'view-all' || state.postTypes.length === 9) {
            dispatch({
                type: SET_POST_TYPES,
                postTypes: []
            });
            value = [];
        }
        else {
            if (target.checked) {
                dispatch({
                    type: ADD_TO_POST_TYPES,
                    postType: target.value
                });
                value = [...state.postTypes, target.value];
            }
            else {
                dispatch({
                    type: REMOVE_FROM_POST_TYPES,
                    postType: target.value
                });
                value = state.postTypes.filter((postType) => target.value !== postType);
            }
        }
        dispatch({
            type: SET_FILTERED_POSTS,
            ...state,
            postTypes: value
        });
    };
    const checked = (value) => {
        if (value === 'view-all' && state.postTypes.length === 0) {
            return true;
        }
        return state.postTypes.includes(value);
    };
    return (_jsxs(motion.article, { initial: "out", variants: variants, animate: "in", exit: "out", onAnimationStart: handleEnter, className: "w-full p-6 bg-white pointer-events-auto space-y-6 tablet-portrait:w-[65%] tablet-portrait:top-[15%] tablet-portrait:relative tablet-landscape:w-[50%] laptop:w-76", children: [_jsxs("header", { className: "flex items-center justify-between space-x-4 tablet-landscape:pointer-events-none", onClick: () => setExpanded(!expanded), children: [_jsxs("h3", { className: "text-gold-700", children: ["Explore the ", _jsx("br", {}), "Scenic Rim"] }), _jsxs("div", { className: "relative flex-none w-6 h-2 tablet-landscape:hidden", children: [_jsx("div", { className: `absolute block w-6/12 rounded-sm transition-all duration-200 bg-green top-1/2 left-1/2 h-0.75 -translate-y-4/10 -translate-x-1/2 ${expanded ? '-rotate-45' : 'rotate-45'}` }), _jsx("div", { className: `absolute block w-6/12 rounded-sm transition-all duration-200 bg-green ml-[7px] top-1/2 left-1/2 h-0.75 -translate-y-4/10 -translate-x-1/2 ${expanded ? 'rotate-45' : '-rotate-45'}` })] })] }), _jsx(AnimatePresence, { initial: false, children: expanded && (_jsx(motion.div, { initial: "collapsed", animate: "open", exit: "collapsed", variants: {
                        open: { opacity: 1, height: 'auto' },
                        collapsed: { opacity: 0, height: 0 }
                    }, transition: { duration: 0.25, ease: [0.04, 0.62, 0.23, 0.98] }, className: "border-t-4 border-green space-y-3", children: choices.length && choices.map((choice, i) => _jsx(Checkbox, { name: "postTypes", icon: choice.icon, label: choice.label, checked: checked(choice.value), handleChange: handleChange, value: choice.value }, i)) }, "content")) })] }));
};
export default RegionalMapFilters;
